/**
 * Store efêmero (vida = sessão SPA) das linhas de log ao vivo de onboarding ZTNA,
 * por job_id. Alimentado pelos eventos SSE `ztna.job.progress` (useZtnaJobRealtime).
 *
 * Efêmero de propósito: no reload, o JobDetailDrawer reconstrói a timeline a partir
 * de `completed_steps` (persistente). Aqui só vivem as linhas da sessão corrente.
 *
 * Exposto via useSyncExternalStore para o banner/drawer re-renderizarem a cada linha.
 */
export interface JobLogLine {
  step: string
  phase: string
  percent: number
  message: string
  elapsed_seconds: number
  ts: number
}

const logs = new Map<number, JobLogLine[]>()
const listeners = new Set<() => void>()

function emit(): void {
  listeners.forEach((l) => l())
}

export const ztnaJobLogStore = {
  append(jobId: number, line: JobLogLine): void {
    const arr = logs.get(jobId) ?? []
    logs.set(jobId, [...arr, line])
    emit()
  },
  get(jobId: number | null | undefined): JobLogLine[] {
    return jobId == null ? EMPTY : logs.get(jobId) ?? EMPTY
  },
  clear(jobId: number): void {
    if (logs.delete(jobId)) emit()
  },
  subscribe(listener: () => void): () => void {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  },
}

// Referência estável para "sem linhas" — evita loop de re-render no
// useSyncExternalStore (getSnapshot precisa ser referencialmente estável).
const EMPTY: JobLogLine[] = []
